import React from "react"
import { StaticQuery, Link, graphql } from "gatsby"
import styled from 'styled-components'

const ArchiveList = styled.ul`
  list-style: none;
  margin-left: 0;
`

const POST_ARCHIVE_QUERY = graphql`
  query BlogPostArchvieQuery {
    allMarkdownRemark(
      limit: 10
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { published: { eq: true } } }
    ) {
      edges {
        node {
          frontmatter {
            title
            slug
          }
        }
      }
    }
  }
`

const Archive = () => (
  <StaticQuery
    query={POST_ARCHIVE_QUERY}
    render={({allMarkdownRemark}) => (
      <>
        <aside>
          <h3>Ostatnie Projekty</h3>
          <ArchiveList>
            {allMarkdownRemark.edges.map(post => (
            <li key={post.node.frontmatter.slug}><Link to={`/projects${post.node.frontmatter.slug}`}>{post.node.frontmatter.title}</Link></li>
            ))}
          </ArchiveList>
        </aside>
      </>
    )}
  />
)

export default Archive
